import React, {useState, useEffect, useRef } from "react";
import { RightScanWrapper, TitleLogo, ToggleButton, PostList, MonthSection, MonthTitle, SectionPosts, TitleSection, ItemLink, ToggleText } from "./RightScan.Styles";
import {blogCardData} from './../../../localData/blogCardData'
import { useNavigate } from "react-router-dom";
import {theme} from './../../../styles/theme';
import {
  useIsDesktopMedium,
  useIsDesktopOrLaptop, 
  useIsMiniNotebook, 
  useIsMobileBig, 
  useIsMobileMedium, 
  useIsMobileMini 
} from './../../../styles/theme';
import { Title } from "@components/atoms/Title/Title";

export const RightScan: React.FC = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [expandedMonths, setExpandedMonths] = useState<{ [key: string]: boolean }>({});
  const navigate = useNavigate(); 
  const wrapperRef = useRef<HTMLDivElement>(null); // ⬅️ Criando referência 
  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

   // Criando refs para armazenar a posição do toque
   const touchStartX = useRef<number | null>(null);
   const touchEndX = useRef<number | null>(null);

    const breakpoints = {
      isDesktopMedium: useIsDesktopMedium(),
      isDesktopOrLaptop: useIsDesktopOrLaptop(),
      isMiniNotebook: useIsMiniNotebook(),
      isMobileBig: useIsMobileBig(),
      isMobileMedium: useIsMobileMedium(),
      isMobileMini: useIsMobileMini(),
    };
  
    useEffect(() => {
      if (breakpoints.isMiniNotebook || breakpoints.isMobileBig || breakpoints.isMobileMedium) {
        setIsCollapsed(true);
      }
    }, [breakpoints.isMiniNotebook, breakpoints.isMobileBig, breakpoints.isMobileMedium]);

    //detecta clique fora da guia direita
    useEffect(() => {
      function handleClickOutside(event: MouseEvent) {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
          setIsCollapsed(true); // Fecha a guia apenas se estiver aberta
        }
      }

      // Adiciona o evento apenas se a guia estiver aberta e a tela for menor que "isDesktopOrLaptop"
      if (!isCollapsed && (breakpoints.isMiniNotebook || breakpoints.isMobileBig || breakpoints.isMobileMedium)) {
        document.addEventListener("mousedown", handleClickOutside);
      }
  
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [isCollapsed, breakpoints.isMiniNotebook, breakpoints.isMobileBig, breakpoints.isMobileMedium]);

    useEffect(() => {
      function handleTouchStart(event: TouchEvent) {
        touchStartX.current = event.touches[0].clientX;
      }
  
      function handleTouchMove(event: TouchEvent) {
        touchEndX.current = event.touches[0].clientX;
      }
  
      function handleTouchEnd() {
        if (touchStartX.current !== null && touchEndX.current !== null) {
          const diff = touchStartX.current - touchEndX.current;
          
          if (diff > 50) {
            // Arrastou para a esquerda → abre a guia
            setIsCollapsed(false);
          } else if (diff < -50) {
            // Arrastou para a direita → fecha a guia
            setIsCollapsed(true);
          }
        }
        
        // Resetar os valores
        touchStartX.current = null;
        touchEndX.current = null;
      }
  
      if (breakpoints.isMiniNotebook || breakpoints.isMobileBig || breakpoints.isMobileMedium) {
        document.addEventListener("touchstart", handleTouchStart);
        document.addEventListener("touchmove", handleTouchMove);
        document.addEventListener("touchend", handleTouchEnd);
      }
  
      return () => {
        document.removeEventListener("touchstart", handleTouchStart);
        document.removeEventListener("touchmove", handleTouchMove);
        document.removeEventListener("touchend", handleTouchEnd);
      };
    }, [breakpoints.isMiniNotebook, breakpoints.isMobileBig, breakpoints.isMobileMedium]);
  

  const toggleMonth = (month: string) => {
    setExpandedMonths((prev) => ({ ...prev, [month]: !prev[month] }));
  };

  const width = breakpoints.isMobileMini
  ? "265px"
  : breakpoints.isMobileMedium
  ? "300px"
  : breakpoints.isMobileBig
  ? "300px"
  : breakpoints.isMiniNotebook
  ? "315px"
  : breakpoints.isDesktopOrLaptop
  ? "320px"
  : breakpoints.isDesktopMedium
  ? "320px"
  : "360px";

    console.log(breakpoints)

  return (
    <RightScanWrapper ref={wrapperRef} {...breakpoints} width={width} isCollapsed={isCollapsed}>
      <TitleLogo {...breakpoints}>
          Viva Modo Saudável
      </TitleLogo>

      {!breakpoints.isDesktopOrLaptop && !breakpoints.isMiniNotebook && (
        <ToggleButton onClick={toggleCollapse}>
          Menu Site 
          <ToggleText isCollapsed={isCollapsed}>{isCollapsed ? " abrir" : " fechar"}</ToggleText>
        </ToggleButton>
      )}
      { (breakpoints.isMobileMini || breakpoints.isMobileMedium || breakpoints.isMobileBig) && (
        <ToggleButton onClick={toggleCollapse}>
          Menu Site 
          <ToggleText isCollapsed={isCollapsed}>{isCollapsed ? " abrir" : " fechar"}</ToggleText>
        </ToggleButton>
      )}
      {!isCollapsed && (
        <SectionPosts>
            <TitleSection {...breakpoints}>Últimos Posts</TitleSection>
            <PostList>
            {blogCardData.map((post, index) => (
              <li key={index}>
                <ItemLink {...breakpoints} as="a" href={post.routeCard} style={{ cursor: "pointer" }}>
                  <span>{post.date}</span> - {post.shortTitle}
                </ItemLink>
              </li>
            ))}
          </PostList>

          <TitleSection {...breakpoints}>Arquivo</TitleSection>
          {Object.values(
            blogCardData.reduce((acc, post) => {
            acc[post.month] = acc[post.month] || [];
            acc[post.month].push(post);
            return acc;
          }, {} as Record<string, typeof blogCardData>)
        ).map((posts, index) => {
            const month = posts[0].month;
            return (
              <MonthSection key={index}>
                <MonthTitle {...breakpoints} onClick={() => toggleMonth(month)}>
                  {month} {expandedMonths[month] ? "▼" : "▲" }
                </MonthTitle>
                {expandedMonths[month] && (
                  <PostList>
                    {posts.map((post, i) => (
                      <li key={i}>
                        <ItemLink {...breakpoints} as="a" href={post.routeCard} style={{ cursor: "pointer" }}>
                          <span>{post.date}</span> - {post.shortTitle}
                        </ItemLink>
                      </li>
                    ))}
                  </PostList>
                )}
              </MonthSection>
            );
          })}
        </SectionPosts>
      )}
    </RightScanWrapper>
  );
};

/*


import React, {useState, useEffect, useRef } from "react";
import { RightScanWrapper, TitleLogo, ToggleButton, PostList, MonthSection, MonthTitle, SectionPosts, TitleSection, ItemLink, ToggleText } from "./RightScan.Styles";
import {blogCardData} from './../../../localData/blogCardData'
import { useNavigate } from "react-router-dom";
import {theme} from './../../../styles/theme';
import {useIsDesktopOrLaptop, 
  useIsMiniNotebook, 
  useIsMobileBig, 
  useIsMobileMedium, 
  useIsMobileMini 
} from './../../../styles/theme';
import { Title } from "@components/atoms/Title/Title";

export const RightScan: React.FC = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [expandedMonths, setExpandedMonths] = useState<{ [key: string]: boolean }>({});
  const navigate = useNavigate(); 
  const wrapperRef = useRef<HTMLDivElement | null>(null); // ⬅️ Criando referência 
  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

 

    const breakpoints = {
      isDesktopOrLaptop: useIsDesktopOrLaptop(),
      isMiniNotebook: useIsMiniNotebook(),
      isMobileBig: useIsMobileBig(),
      isMobileMedium: useIsMobileMedium(),
      isMobileMini: useIsMobileMini(),
    };
  
    useEffect(() => {
      if (breakpoints.isMiniNotebook || breakpoints.isMobileBig || breakpoints.isMobileMedium) {
        setIsCollapsed(true);
      }
    }, [breakpoints.isMiniNotebook, breakpoints.isMobileBig, breakpoints.isMobileMedium]);

    //detecta clique fora da guia direita
    useEffect(() => {
      function handleClickOutside(event: MouseEvent) {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
          setIsCollapsed(true); // Fecha a guia apenas se estiver aberta
        }
      }

      // Adiciona o evento apenas se a guia estiver aberta e a tela for menor que "isDesktopOrLaptop"
      if (!isCollapsed && (breakpoints.isMiniNotebook || breakpoints.isMobileBig || breakpoints.isMobileMedium)) {
        document.addEventListener("mousedown", handleClickOutside);
      }
  
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [isCollapsed, breakpoints.isDesktopOrLaptop]);

  const toggleMonth = (month: string) => {
    setExpandedMonths((prev) => ({ ...prev, [month]: !prev[month] }));
  };

  const width = breakpoints.isMobileMini
  ? "265px"
  : breakpoints.isMobileMedium
  ? "300px"
  : breakpoints.isMobileBig
  ? "315px"
  : breakpoints.isMiniNotebook
  ? "330px"
  : breakpoints.isDesktopOrLaptop
  ? "345px"
  : "360px";

    console.log(breakpoints)

  return (
    <RightScanWrapper ref={wrapperRef} {...breakpoints} width={width} isCollapsed={isCollapsed}>
      <TitleLogo {...breakpoints}>
          Viva Modo Saudável
      </TitleLogo>

      {!breakpoints.isDesktopOrLaptop && !breakpoints.isMiniNotebook && (
        <ToggleButton onClick={toggleCollapse}>
          Menu Site 
          <ToggleText isCollapsed={isCollapsed}>{isCollapsed ? " abrir" : " fechar"}</ToggleText>
        </ToggleButton>
      )}
      { (breakpoints.isMobileMini || breakpoints.isMobileMedium || breakpoints.isMobileBig) && (
        <ToggleButton onClick={toggleCollapse}>
          Menu Site 
          <ToggleText isCollapsed={isCollapsed}>{isCollapsed ? " abrir" : " fechar"}</ToggleText>
        </ToggleButton>
      )}
      {!isCollapsed && (
        <SectionPosts>
            <TitleSection {...breakpoints}>Últimos Posts</TitleSection>
            <PostList>
            {blogCardData.map((post, index) => (
              <li key={index}>
                <ItemLink {...breakpoints} onClick={() => navigate(post.routeCard)} style={{ cursor: "pointer" }}>
                  <span>{post.date}</span> - {post.shortTitle}
                </ItemLink>
              </li>
            ))}
          </PostList>

          <TitleSection {...breakpoints}>Arquivo</TitleSection>
          {Object.values(
            blogCardData.reduce((acc, post) => {
            acc[post.month] = acc[post.month] || [];
            acc[post.month].push(post);
            return acc;
          }, {} as Record<string, typeof blogCardData>)
        ).map((posts, index) => {
            const month = posts[0].month;
            return (
              <MonthSection key={index}>
                <MonthTitle {...breakpoints} onClick={() => toggleMonth(month)}>
                  {month} {expandedMonths[month] ? "▼" : "▲" }
                </MonthTitle>
                {expandedMonths[month] && (
                  <PostList>
                    {posts.map((post, i) => (
                      <li key={i}>
                        <ItemLink {...breakpoints} onClick={() => navigate(post.routeCard)} style={{ cursor: "pointer" }}>
                          <span>{post.date}</span> - {post.shortTitle}
                        </ItemLink>
                      </li>
                    ))}
                  </PostList>
                )}
              </MonthSection>
            );
          })}
        </SectionPosts>
      )}
    </RightScanWrapper>
  );
};









*/